// removed by extract-text-webpack-plugin
module.exports = {"storeLayout":"_8EOiv","downloadBanner":"_1FYDQ","promoBanner":"_2jTVy"};


//////////////////
// WEBPACK FOOTER
// ./banquet/layouts/StoreLayout/index.sass
// module id = 1530
// module chunks = 1